import React from 'react';
import { connect } from 'react-redux';

import { markAsNote } from '../../../../../../../_actions/questionnaire.actions'

const Note = ({ question, dispatch }) => {
  const noteExtension = question.extension.find((extension) => {
    return extension.url === 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note';
  });

  return <div className="form-group">
    <label><strong>HPI</strong></label>
    <div className="custom-control custom-switch">
      <input
        onChange={(e) => { dispatch(markAsNote(question, e.target.checked)) }}
        id={`id_${question.linkId}_note`}
        checked={noteExtension.valueBoolean || false}
        value="note"
        type="checkbox"
        className="custom-control-input" />
      <label
        htmlFor={`id_${question.linkId}_note`}
        className="custom-control-label">Include in HPI</label>
    </div>
  </div>
}

export default connect()(Note);